// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__uxZdk","productName":"Table_productName__3v6Ci"};